<template>
  <el-card v-loading="loading">
  <div ref="scrollContainer" id="page-panel" >
    <!-- <resize-observer @notify="__resizeHanlder" /> -->

      <div class="customer-top-nav">
        <div class="title">
          <span>{{$t('reports.names.'+reportCode)}}</span><br>
        </div>
        <div class="controls no-print">
          <el-dropdown size="small" type="default" class="">
            <el-button type="primary" size="small">
              <i class="el-icon-download"></i>
            </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="downloadReport('csv')"><i class="mdi mdi-file-excel"/> CSV</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
           <el-button type="primary" @click="openFilterDialog" size="small"><i class="mdi mdi-filter"></i> </el-button>
        </div>
      </div>

      <p>
        <span class="fs-14 secondary-text">{{companyName}}</span><br>
        <span class="fs-14 secondary-text" >En date du : {{_moment(this.filters.date)}}</span>
        <span v-if="filters.currencies.length > 0">
          <br>
          <span class="fs-14 secondary-text">Devise(s) : <span v-for="(cur, index) in filters.currencies">{{cur.code}}<span v-if="index < (filters.currencies.length -1)">, </span></span></span>
        </span>
        <span v-else class="fs-14 secondary-text">
          <br> Toutes les devises
        </span>
        <span v-if="selectedSalesRep != null && selectedSalesRep.length > 0">
          <br>
          <span class="fs-14 secondary-text">Représentant(s) : <span v-for="(rep, index) in selectedSalesRep">{{rep}}<span v-if="index < (selectedSalesRep.length -1)">, </span></span></span>
        </span>
        <span v-else class="fs-14 secondary-text">
          <br> Toutes les représentants
        </span>
      </p>
      <div id="printMe">

      <el-table
        :data="usableData"
        :style="tableWidth"
        stripe
        empty-text="Il n'y a aucun compte selon les paramètres">
        <el-table-column   label="Client" prop="name" sortable>
          <template slot-scope="scope">
            <PortausLink v-if="!scope.row.header" fs="fs-12" :label="scope.row.name" :id="scope.row.id" path="/customers/"></PortausLink>

            <span v-else><strong>{{scope.row.name}}</strong></span>

          </template>
        </el-table-column>
        <el-table-column label="0-30 jours" align="center">
          <template slot-scope="scope">
            <span class="fs-12" v-if="scope.row.slots[1]!=null">
              <div v-for="(curTotal, key) in getOrderedslotCurrency(scope.row.slots[1])">
                <span v-if="curTotal.total != null">{{$n(curTotal.total, 'currency', key)}}</span>
                <span v-else>- -</span>
              </div>
            </span>
            <span v-else>- -</span>
          </template>
        </el-table-column>
        <el-table-column label="31-60 jours" align="center">
          <template slot-scope="scope">
            <span class="fs-12" v-if="scope.row.slots[2]!=null">
              <div v-for="(curTotal, key) in getOrderedslotCurrency(scope.row.slots[2])">
                <span v-if="curTotal.total != null">{{$n(curTotal.total, 'currency', key)}}</span>
                <span v-else>- -</span>
              </div>
            </span>
            <span v-else>- -</span>
          </template>
        </el-table-column>
        <el-table-column label="61-90 jours" align="center">
          <template slot-scope="scope">
            <span class="fs-12" v-if="scope.row.slots[3]!=null">
              <div v-for="(curTotal, key) in getOrderedslotCurrency(scope.row.slots[3])">
                <span v-if="curTotal.total != null">{{$n(curTotal.total, 'currency', key)}}</span>
                <span v-else>- -</span>
              </div>
            </span>
            <span v-else>- -</span>
          </template>
        </el-table-column>
        <el-table-column label="+90 jours" align="center">
          <template slot-scope="scope">
            <span class="fs-12" v-if="scope.row.slots[4]!=null">
              <div v-for="(curTotal, key) in getOrderedslotCurrency(scope.row.slots[4])">
                <span v-if="curTotal.total != null">{{$n(curTotal.total, 'currency', key)}}</span>
                <span v-else>- -</span>
              </div>
            </span>
            <span v-else>- -</span>
          </template>
        </el-table-column>
        <el-table-column label="Total" align="right">
          <template slot-scope="scope">
            <div v-for="(curTotal, key) in getOrderedslotCurrency(scope.row.total)">
              <span v-if="curTotal.total != null" class="fs-12">{{$n(curTotal.total, 'currency', key)}}</span>
              <span v-else class="fs-12">- -</span>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <reportFilter :visible="reportFilterVisible"
                  @close="closeFilterDialog"
                  predefinePeriodLabelCode="AsOf"
                  :period="period"
                  :predefinedPeriod="predefinedPeriod"
                  :date="filters.date"
                  :reps="filterUserWithRoleRep"
                  :selectedReps="getUserById(filters.reps)"
                  :currencies="currencies"
                  :selectedCurrencies="filters.currencies"
                  @applyFilter="handleFilter">
    </reportFilter>
  </div>
</el-card>
</template>
<script>
//import Section
import salesAPI from '@/services/API/sales.js'
import moment from 'moment'
import reportUtil from '@/utils/report-util.js'
import reportFilter from './report-filter'
import PortausLink from '@/components/portaus-link'
import { mapActions, mapState, mapGetters } from 'vuex';

export default {
  name : "report-aging",
  props : {
    width : {
      type : Number,
      default : 100
    },
    fiscalEndDay : Number,
    fiscalEndMonth : Number,
    lastFiscalYearDate : Object,
    fiscalYearDate : Object,
    month : Object,
    lastMonth : Object,
    companyName : '',
  },
  data() {
    return {
      output : null,
      data : [],
      loading:true,
      reportFilterVisible : false,
      filters : {
        range : 'TODAY',
        date : null,
        reps : [],
        currencies: [],
      },
      pageWidth : null,
      pageHeight : null,

    };
  },
  components : {
    reportFilter,
    PortausLink
  },
  computed : {
    selectedSalesRep () {
      if (this.filters.reps == null || this.filters.reps.length ==  0) return null;
      let repsName = [];
      const users = this.getUserById(this.filters.reps);
      return _.map(users, user => (`${user.first_name} ${user.last_name}`))
    },
    period(){
      return _.find(this.predefinedPeriod, p=>{return p.code==this.filters.range})
    },
    predefinedPeriod(){
      if(this.fiscalYearDate.startDate!=null && this.fiscalYearDate.endDate!=null){
        return [
          {code : 'TODAY', description : moment().format('DD MMM YYYY')},
          {code : 'END_OF_MONTH', description:this.month.endDate.format('DD MMM YYYY')},
          {code : 'END_OF_LAST_MONTH', description:this.lastMonth.endDate.format('DD MMM YYYY')},
          {code : 'CUSTOM', range:false}
        ]
      }else{
        return [];
      }

    },
    tableWidth(){
      return 'width : ' + this.width + 'px;';
    },
    reportCode(){
      return this.$route.params.code;
    },
    usableData(){
      if (this.data.lines != null) {
        return [...this.data.lines, ...[this.data.total]];
      }
      return [];

    },
    ...mapGetters('users',['filterUserWithRoleRep','getUserById']),
    ...mapState('controlData', ['currencies']),
    ...mapGetters(['isStrictFilteredByRep', 'isCurrentUserRep', 'getCurrentUserId', 'isCurrentUserAdmin']),
  },
  methods : {
    getOrderedslotCurrency (slotCurrency) {
      const sortedSlotCurKeys = _.orderBy(Object.keys(slotCurrency), 0);
      const sortedSlotCur = {};
      _.forEach(sortedSlotCurKeys, (key) => {
        sortedSlotCur[key] = slotCurrency[key];
      });
      return sortedSlotCur;
    },
    downloadReport(format){
      let filters = _.cloneDeep(this.filters);
      if(filters.date!=null){
        filters.date = moment(filters.date).format('YYYY-MM-DD Z');
      }

      filters.format=format

      let filename = 'AGING_'+moment(this.filters.date).format('YYYY-MM-DD Z');
      filename+="."+format;

      return salesAPI.downloadSalesReport(this.reportCode, filename, filters);
    },
    handleFilter(filters){

      localStorage.aging_range=filters.period.code;
      localStorage.aging_date = filters.date;

      localStorage.aging_currencies = JSON.stringify(filters.currencies);

      let reps = [];
      _.forEach(filters.reps, m=>{
        reps.push(m.id);
      })
      localStorage.aging_reps = JSON.stringify(reps);

      this.setFilters();
      this.fetchData();
    },
    openFilterDialog(){
      this.reportFilterVisible = true;
    },
    closeFilterDialog(){
      this.reportFilterVisible=false;
    },
    openCustomer(customerId){
      var index='/customers/'+customerId;
			this.$router.push(index);
    },
    _moment(date, format='l'){
      return moment(date).format(format);
    },
    arraySpanMethod({ row, column, rowIndex, columnIndex }) {
        if(row.span){
          return {rowspan:1, colspan:this.nbColums+2}
        }else{
          return {rowspan:1, colspan:1}
        }
      },

		setPageWidth() {
			this.pageWidth = document.getElementById('page-panel').offsetWidth;
			this.pageHeight = document.getElementById('page-panel').offsetHeight;
		},
    __resizeHanlder: _.throttle(function (e) {
  			this.setPageWidth();
  		}, 700),
    fetchData(){
      this.loading = true;
      this.total = 0.00;

      let filters = _.cloneDeep(this.filters);
      if(filters.date!=null){
        filters.date = moment(filters.date).format('YYYY-MM-DD Z');
      }

      filters.currencyId = [];
      _.forEach(filters.currencies, cur => {
        filters.currencyId.push(cur.id);
      })
      delete filters.currencies;

      return salesAPI.getReportInfo(this.reportCode, filters)
        .then(data=>{
          this.data = data;
          this.loading = false;
        }).catch(err=>{
          console.log(err);
          this.loading = false;
          this.$message.error('Une erreur système est survenue. Veuillez réessayer plus tard')
        })
    },
    setFilters(){
      if(localStorage.aging_range==null){
        localStorage.aging_range='TODAY';
      }

      this.filters.range=localStorage.aging_range;

      this.filters.reps=localStorage.aging_reps!=null ? JSON.parse(localStorage.aging_reps) : [];

      this.filters.currencies=localStorage.aging_currencies!=null ? JSON.parse(localStorage.aging_currencies) : [];

      if(this.filters.range=='TODAY' ){
        localStorage.aging_date = new moment();
      }else if(this.filters.range=='END_OF_MONTH' ){
        localStorage.aging_date = this.month.endDate;
      }else if(this.filters.range=='END_OF_LAST_MONTH'){
        localStorage.aging_date = this.lastMonth.endDate;
      }

      this.filters.date = localStorage.aging_date;
    },
    ...mapActions('users', ['fetchAdminUsers']),
    ...mapActions('controlData', ['fetchCurrencies']),
  },
  mounted(){
    this.setPageWidth();
    this.fetchAdminUsers();
    this.fetchCurrencies();
  },
  created(){
    
    this.loading = true;
    this.setFilters();
    if (this.isStrictFilteredByRep === true && this.isCurrentUserRep === true && !this.isCurrentUserAdmin) {
        this.filters.reps = [this.getCurrentUserId];
      }
    this.fetchData();
  },
  beforeDestroy(){
    this.data = [];
  }
}
</script>
<style lang="scss" scoped>
@import '../../../../../assets/scss/_variables';


.title {
	font-size : 1.6em;
	font-weight:bold;
	margin-right:20px;
	position:relative;
	float:left;
}
.customer-top-nav{
  height:40px;
}

.controls{
	position:relative;
	float:right;

	button{
		margin-left:20px;
	}
}


</style>
